import { render, staticRenderFns } from "./showActivitiesWidget.vue?vue&type=template&id=73c7fd64"
import script from "./showActivitiesWidget.ts?vue&type=script&lang=ts&external"
export * from "./showActivitiesWidget.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports